import Vue from 'vue'
import Router from 'vue-router'
import FairDetail from '@/views/template1/FairDetail'
import FairDetail1 from '@/views/template1/FairDetail1'
import FairBuy from '../views/template1/FairBuy'
import HotelList from '../views/template1/HotelList'
import FairList from '../views/template1/FairList'
import Form from '../views/template1/Form'
import SingleCode from '../views/template1/SingleCode'
import SingleTicket from '../views/template1/SingleTicket'
import SingleCheckOrder from '../views/template1/SingleCheckOrder'
import SingleMy from '../views/template1/SingleMy'
import TermContent from '../views/template1/TermContent'
import Content from '../views/template1/Content'
import SingleGuest from '../views/template1/SingleGuest'
import ArticleList from '../views/template1/ArticleList'
import PuckUp from '../views/template1/PuckUp'
import HotelRoom from '../views/template1/HotelRoom'

import index from '../views/template1/index'
import FairPay from '../views/template1/FairPay'
import FairPay2 from '../views/template1/FairPay2'
import WeixinPay from '../views/template1/WeixinPay'
import RoomBuy from '../views/template1/RoomBuy'
import InvoiceDetail from '../views/template1/InvoiceDetail'
import InvoiceUpdate from '../views/template1/InvoiceUpdate'
import InvoiceCreate from '../views/template1/InvoiceCreate'
import BankTransfer from '../views/template1/BankTransfer'
import MeetUpdate from '../views/template1/MeetUpdate'
import MeetCreate from '../views/template1/MeetCreate'
import setting from '../views/template1/setting'
import changePassword from '../views/template1/changePassword'

// import FairDetail2 from '@/views/template2/FairDetail'
// import FairBuy2 from '../views/template2/FairBuy'
// import HotelList2 from '../views/template2/HotelList'
// import SingleCode2 from '../views/template2/SingleCode'
// import SingleTicket2 from '../views/template2/SingleTicket'
// import SingleCheckOrder2 from '../views/template2/SingleCheckOrder'
// import SingleMy2 from '../views/template2/SingleMy'
// import TermContent2 from '../views/template2/TermContent'
// import Content2 from '../views/template2/Content'
// import SingleGuest2 from '../views/template2/SingleGuest'
// import ArticleList2 from '../views/template2/ArticleList'
// import PuckUp2 from '../views/template2/PuckUp'
// import HotelRoom2 from '../views/template2/HotelRoom'
//
// import index2 from '../views/template2/index'
// import FairPay2 from '../views/template2/FairPay'
// import RoomBuy2 from '../views/template2/RoomBuy'
// import InvoiceDetail2 from '../views/template2/InvoiceDetail'
// import InvoiceUpdate2 from '../views/template2/InvoiceUpdate'
// import InvoiceCreate2 from '../views/template2/InvoiceCreate'
// import MeetUpdate2 from '../views/template2/MeetUpdate'
// import MeetCreate2 from '../views/template2/MeetCreate'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/fair-list',
      name: '会议列表',
      component: FairList,
      meta: {
        title: '会议列表'
      }
    },
    {
      path: '/form/:id',
      name: '问卷调查',
      component: Form,
      meta: {
        title: '问卷调查'
      }
    },
    {
      path: '/',
      name: '首页',
      component: index,
      meta: {
        title: '首页'
      },
      children: [
        {
          path: '/:id',
          name: '会议首页',
          component: FairDetail,
          meta: {
            title: '会议首页'
          }
        },
        {
          path: '/:id/setting',
          name: '系统设置',
          component: setting,
          meta: {
            title: '系统设置'
          }
        },
      ]
    },
    {
      path: '/:id/fair-pay/:order_id',
      name: '支付',
      component: FairPay,
      meta: {
        title: '支付'
      }
    },
    {
      path: '/:id/fair-pay2/:order_id',
      name: '商品支付',
      component: FairPay2,
      meta: {
        title: '商品支付'
      }
    },
    {
      path: '/:id/weixin-pay',
      name: '微信支付',
      component: WeixinPay,
      meta: {
        title: '微信支付'
      }
    },
    {
      path: '/:id/hotel-list',
      name: '酒店预订',
      component: HotelList,
      meta: {
        title: '酒店预订'
      }
    },

    {
      path: '/:id/single-code',
      name: '参会凭证',
      component: SingleCode,
      meta: {
        title: '参会凭证'
      }
    },
    {
      path: '/:id/single-ticket',
      name: '我的参会凭证',
      component: SingleTicket,
      meta: {
        title: '我的参会凭证'
      }
    },
    {
      path: '/:id/single-check-order',
      name: '查询订单',
      component: SingleCheckOrder,
      meta: {
        title: '查询订单'
      }
    },
    {
      path: '/:id/puck-up',
      name: '接机',
      component: PuckUp,
      meta: {
        title: '接机'
      }
    },
    {
      path: '/:id/term-content/:termid',
      name: '栏目内容',
      component: TermContent,
      meta: {
        title: '栏目内容'
      }
    },
    {
      path: '/:id/content/:articleid',
      name: '内容',
      component: Content,
      meta: {
        title: '内容'
      }
    },
    {
      path: '/:id/single-guest/:termid',
      name: '嘉宾',
      component: SingleGuest,
      meta: {
        title: '嘉宾'
      }
    },
    {
      path: '/:id/Article-list/:termid',
      name: '列表页',
      component: ArticleList,
      meta: {
        title: '列表页'
      }
    },
    {
      path: '/:id/hotel-room/:hotelid',
      name: '房间列表',
      component: HotelRoom,
      meta: {
        title: '房间列表'
      }
    },
    {
      path: '/:id/room-buy',
      name: '预订',
      component: RoomBuy,
      meta: {
        title: '预订'
      }
    },
    {
      path: '/:id/invoice-detail/:invid',
      name: '查看发票',
      component: InvoiceDetail,
      meta: {
        title: '查看发票'
      }
    },
    {
      path: '/:id/invoice-update/:invid',
      name: '修改发票',
      component: InvoiceUpdate,
      meta: {
        title: '修改发票'
      }
    },
    {
      path: '/:id/invoice-create/:order_id',
      name: '补开发票',
      component: InvoiceCreate,
      meta: {
        title: '补开发票'
      }
    },
    {
      path: '/:id/change-password',
      name: '修改密码',
      component: changePassword,
      meta: {
        title: '修改密码'
      }
    },
    {
      path: '/:id/my',
      name: '长图首页',
      component: FairDetail1,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/:id/fair-buy',
      name: '报名',
      component: FairBuy,
      meta: {
        title: '报名'
      }
    },
    {
      path: '/:id/meet-update/:meet_id',
      name: '修改接机',
      component: MeetUpdate,
      meta: {
        title: '修改接机'
      }
    },
    {
      path: '/:id/meet-create',
      name: '添加接机',
      component: MeetCreate,
      meta: {
        title: '添加接机'
      }
    },
    {
      path: '/:id/bank-transfer/:order_id',
      name: '银行转账',
      component: BankTransfer,
      meta: {
        title: '银行转账'
      }
    },
    {
      path: '/:id/single-my',
      name: '个人中心',
      component: SingleMy,
      meta: {
        title: '个人中心'
      }
    }
    // ,
    // {
    //   path: '/',
    //   name: '首页',
    //   component: index2,
    //   children: [
    //     {
    //       path: '/t1/:id',
    //       name: '会议首页',
    //       component: FairDetail2
    //     },
    //     {
    //       path: '/t1/:id/fair-buy',
    //       name: '报名页面',
    //       component: FairBuy2
    //     },
    //     {
    //       path: '/t1/:id/fair-pay/:order_id',
    //       name: '支付页面',
    //       component: FairPay2
    //     },
    //     {
    //       path: '/t1/:id/hotel-list',
    //       name: '酒店预订',
    //       component: HotelList2
    //     },
    //     {
    //       path: '/t1/:id/single-my',
    //       name: '个人中心',
    //       component: SingleMy2
    //     },
    //     {
    //       path: '/t1/:id/single-code',
    //       name: '参会凭证',
    //       component: SingleCode2
    //     },
    //     {
    //       path: '/t1/:id/single-ticket',
    //       name: '我的参会凭证',
    //       component: SingleTicket2
    //     },
    //     {
    //       path: '/t1/:id/single-check-order',
    //       name: '查询订单',
    //       component: SingleCheckOrder2
    //     },
    //     {
    //       path: '/t1/:id/puck-up',
    //       name: '接机',
    //       component: PuckUp2
    //     },
    //     {
    //       path: '/t1/:id/term-content/:termid',
    //       name: '栏目内容页',
    //       component: TermContent2
    //     },
    //     {
    //       path: '/t1/:id/content/:articleid',
    //       name: '内容页',
    //       component: Content2
    //     },
    //     {
    //       path: '/t1/:id/single-guest/:termid',
    //       name: '嘉宾内容页',
    //       component: SingleGuest2
    //     },
    //     {
    //       path: '/t1/:id/Article-list/:termid',
    //       name: '列表页',
    //       component: ArticleList2
    //     },
    //     {
    //       path: '/t1/:id/hotel-room/:hotelid',
    //       name: '房间列表',
    //       component: HotelRoom2
    //     },
    //     {
    //       path: '/t1/:id/room-buy',
    //       name: '预订',
    //       component: RoomBuy2
    //     },
    //     {
    //       path: '/t1/:id/invoice-detail/:invid',
    //       name: '查看发票',
    //       component: InvoiceDetail2
    //     },
    //     {
    //       path: '/t1/:id/invoice-update/:invid',
    //       name: '修改发票',
    //       component: InvoiceUpdate2
    //     },
    //     {
    //       path: '/t1/:id/invoice-create/:order_id',
    //       name: '补开发票',
    //       component: InvoiceCreate2
    //     },
    //     {
    //       path: '/t1/:id/meet-update/:meet_id',
    //       name: '修改接机信息',
    //       component: MeetUpdate2
    //     },
    //     {
    //       path: '/t1/:id/meet-create',
    //       name: '添加接机信息',
    //       component: MeetCreate2
    //     }
    //   ]
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js